<template>
  <div>
    <v-card max-width="800" class="shadcard" @click="openCategory">
      <div class="pa-6">
        <div class="d-flex align-center justify-space-between">
          <h1>
            {{ category.name }}
          </h1>
          <v-chip
            v-if="type !== 'template' && category.status !== 'suggested'"
            size="small"
            variant="flat"
            :color="category.active ? 'success' : 'info'"
            class="ml-2 font-weight-medium px-3"
            ><v-icon size="small" class="mr-2"
              >mdi-{{ category.active ? "play" : "pause" }}</v-icon
            >
            {{ category.active ? "Active" : "Paused" }}</v-chip
          >
          <v-chip
            v-if="category.status === 'suggested'"
            size="small"
            variant="flat"
            style="
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            "
            color="muted"
            class="ml-2 font-weight-medium px-3"
            ><v-icon class="mr-2">mdi-creation</v-icon> Suggested</v-chip
          >
        </div>
        <div
          class="mb-4"
          v-html="category.description"
          v-if="type === 'template'"
        ></div>
        <div class="d-flex" style="gap: 10px" v-if="type !== 'template'">
          <v-icon size="small" color="muted">mdi-calendar-outline</v-icon>
          <p style="font-size: 11pt" class="text-muted">
            {{
              category.schedule ? getSchedule(category.schedule) : "No schedule"
            }}
          </p>
        </div>
        <!-- <div class="d-flex my-3 flex-wrap" style="gap: 5px">
          <v-chip
            v-for="keyword in category.keywords"
            :key="keyword"
            size="small"
            variant="flat"
            class="chipbg"
          >
            {{ keyword }}
          </v-chip>
        </div> -->
        <!-- <div
          class="mt-6"
          style="display: grid; grid-template-columns: 1fr; gap: 50px"
        >
          <div v-if="category.goals.length > 0">
            <p style="font-size: 10pt; font-weight: 600" class="text-muted">
              Goals
            </p>
            <p
              style="
                font-size: 10pt;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
              "
            >
              {{ category.goals.join(" ") }}
            </p>
          </div>
          <div v-if="type !== 'template'">
            <p style="font-size: 10pt; font-weight: 600" class="text-muted">
              Sources
            </p>

            <p
              style="
                font-size: 10pt;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
              "
            >
              {{ sources.map((source) => source.name).join(", ") }}
            </p>
          </div>
        </div> -->
      </div>
      <v-divider></v-divider>
      <div class="d-flex" v-if="type !== 'template'">
        <div
          class="px-6 py-4 d-flex flex-column align-center justify-center"
          style="border-right: 1px solid hsl(214.3 31.8% 91.4%)"
        >
          <p style="font-size: 20pt; font-weight: 600">
            {{
              category.status === "suggested"
                ? category.based_on?.length
                : category.counter?.posts || 0
            }}
          </p>
          <p style="font-size: 9pt; font-weight: 400" class="text-muted">
            {{
              category.status === "suggested"
                ? "Existing posts suggested"
                : "Posts"
            }}
          </p>
        </div>
        <div class="d-flex flex-column align-center justify-center px-6 py-4">
          <p style="font-size: 12pt; font-weight: 600">
            {{
              category.schedule?.last_publish
                ? new Date(
                    category.schedule?.last_publish * 1000
                  ).toLocaleDateString()
                : "Never"
            }}
          </p>
          <p style="font-size: 9pt; font-weight: 400" class="text-muted">
            Last published
          </p>
        </div>
        <v-spacer></v-spacer>

        <div
          class="px-6 py-4 d-flex align-center justify-center"
          style="border-left: 1px solid hsl(214.3 31.8% 91.4%); gap: 15px"
          v-if="category.status === 'suggested'"
        >
          <v-btn
            variant="text"
            color="primary"
            @click.stop="$store.dispatch('deleteCategory', category.uid)"
            >Discard</v-btn
          >

          <KeepCategory :category="category" ref="keepCategory" />
        </div>
      </div>
    </v-card>
    <!-- <v-card
      @click="
        $store.commit('setCategory', category);
        $store.commit('setCategoryShow', true);
      "
      :class="cardClasses"
      :style="{
        ...cardStyle,
        ...{
          display: 'grid',
          gridTemplateColumns:
            category.status === 'suggested' ? '50px 1fr' : '1fr',
        },
      }"
      style="cursor: pointer"
      width="800"
    >
      <div
        v-if="category.status === 'suggested'"
        class="d-flex align-center justify-center"
      >
        <v-icon>mdi-creation</v-icon>
      </div>
      <div>
        <div class="pa-4">
          <div class="d-flex align-center" style="gap: 15px">
            <div>
              <h1 style="font-size: 12pt; line-height: 1.4">
                {{ category.name }}
              </h1>
              <p v-if="category.status === 'suggested'" style="font-size: 10pt">
                <i>Based on 4 previous posts</i>
              </p>
            </div>
          </div>

          <div v-html="category.description"></div>
        </div>
      </div>
    </v-card> -->
  </div>
</template>

<script>
import KeepCategory from "./KeepCategory.vue";

export default {
  components: {
    KeepCategory,
  },
  props: {
    shrink: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: "category",
    },
    sources: {
      type: Array,
      required: false,
      default: () => [],
    },
    category: {
      type: Object,
      required: true,
    },
    selectable: {
      type: Boolean,
      required: false,
      default: false,
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    cardClasses() {
      return {
        "suggested-border":
          this.category && this.category.status === "suggested",
      };
    },
    cardStyle() {
      if (this.category && this.category.status === "suggested") {
        return {
          borderWidth: "1px 4px 4px 1px",
          borderStyle: "solid",
          borderColor: "transparent",
          borderRadius: "6px",
        };
      }

      return {
        borderLeft: "1px solid #212427",
        borderRight: "4px solid #212427",
        borderTop: "1px solid #212427",
        borderBottom: "4px solid #212427",
        borderRadius: "6px",
      };
    },
  },
  watch: {
    selected(v) {
      if (v === false) {
        this.expand = false;
        this.tab = 0;
      }
    },
  },
  data() {
    return {
      expand: false,
      tab: 0,
    };
  },
  methods: {
    openCategory() {
      if (this.type === "template") {
        this.$emit("selectTemplate", this.category);
        return;
      }
      if (this.category.status === "suggested") {
        this.$refs.keepCategory.open();
        return;
      }
      this.$store.commit("setCategory", this.category);
      this.$store.commit("setCategoryShow", true);
    },
    getSchedule(s) {
      if (!s) return "";
      let freq = s.frequency === 1 ? "" : s.frequency;
      let typeSingular =
        s.type && s.type.toLowerCase ? s.type.toLowerCase().slice(0, -1) : "";
      let typeLower = s.type && s.type.toLowerCase ? s.type.toLowerCase() : "";
      let freqType = s.frequency === 1 ? typeSingular : typeLower;

      let text = `Every ${freq} ${freqType}`;

      let days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      if (
        s.type.toLowerCase() === "weeks" ||
        s.type.toLowerCase() === "months"
      ) {
        // Get days of week display, could be array or single value
        let daysTxt = "";
        if (Array.isArray(s.day_of_week)) {
          // Helper to handle array display
          daysTxt = s.day_of_week.map((d) => days[d]).join(", ");
        } else if (
          typeof s.day_of_week === "string" ||
          typeof s.day_of_week === "number"
        ) {
          daysTxt = s.day_of_week;
        }
        text += ` on ${daysTxt}`;
      }

      text += ` at ${s.timeslot}.`;

      return text;
    },
    viewPosts() {
      this.$router.push(`/library`);
      this.$store.commit("setQuery", {
        category: this.category.uid,
        status: "all",
      });
    },
    selectCategory() {
      this.$emit("selectCategory");
    },
    selectSource(v) {
      console.log(v);
    },
  },
};
</script>

<style lang="scss" scoped>
.shadcard {
  border: 1px solid hsl(214.3 31.8% 91.4%);
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

.chipbg {
  background: hsl(210 40% 96.1%);
  color: hsl(222.2 47.4% 11.2%);
}

.suggested-border {
  position: relative;
  background:
    linear-gradient(white, white) padding-box,
    linear-gradient(
        120deg,
        rgba(168, 85, 247, 0.9),
        rgba(56, 189, 248, 0.9),
        rgba(74, 222, 128, 0.9),
        rgba(168, 85, 247, 0.9)
      )
      border-box;
  background-size:
    100% 100%,
    250% 250%;
  animation: flowing-border 6s linear infinite;
  border-radius: 6px;
  transition: background-position 0.3s ease;
}

@keyframes flowing-border {
  0% {
    background-position:
      0% 50%,
      0% 50%;
  }
  50% {
    background-position:
      0% 50%,
      100% 50%;
  }
  100% {
    background-position:
      0% 50%,
      0% 50%;
  }
}
</style>
